import axiosInstance from "./axiosInstance";

// Login
// export const logInApi = async (data) => {
//   const res = await axiosInstance.post('/Dash/login', data);
//   return res.data;
// };


export const logInApi = async (data) => {
  try {
    const res = await axiosInstance.post("/Dash/login", data);
    return res.data; // ✅ success case
  } catch (err) {
    if (err.response && err.response.data) {
      // ✅ backend sent proper error JSON
      return err.response.data;
    }
    // fallback for network errors or unexpected issues
    return {
      success: false,
      error: err.message || "Something went wrong",
      data: null,
      apiErrorCode: -1
    };
  }
};

